import { useContext } from 'react';
import { useSelector } from '@xstate/react';

import { paymentGatewaySelectors } from '../machines';

import { useServices } from './useServices';
import { PaymentProfilesContext } from '../contexts';

export type PaymentMethods = 'credit_card' | 'bank_account';

/**
 * Determines which payment methods could be used for subscription billing
 * @returns {PaymentMethods} Collection of payment methods
 */
export const useAvailablePaymentMethods = (): PaymentMethods[] => {
  const availablePaymentMethods: PaymentMethods[] = [];

  const { subscriptionCurrency } = useContext(PaymentProfilesContext);
  const { paymentGatewayService } = useServices();

  const gateways = useSelector(
    paymentGatewayService,
    paymentGatewaySelectors.getDefaultVaults
  );

  const vaultCurrencies = useSelector(
    paymentGatewayService,
    paymentGatewaySelectors.getVaultCurrencies
  );

  const creditCardGateway = gateways['creditCard'];

  if (
    creditCardGateway &&
    vaultCurrencies[creditCardGateway]?.includes(subscriptionCurrency)
  ) {
    availablePaymentMethods.push('credit_card');
  }

  return availablePaymentMethods;
};
